<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">批改试题</span>
    <div v-if="div_type == 'class'">
      <el-table
        class="class_table_data_style"
        :data="class_table_data"
        border
        stripe
      >
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Name" label="班级"></el-table-column>
        <el-table-column label="操作" min-width="70">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-s-promotion"
              size="mini"
              @click="to_testPaper(scope.row)"
            >
              进入试卷
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="question_bank" v-if="div_type == 'question_bank'">
      <el-button
        @click="return_pag('class')"
        class="question_bank_but"
        size="mini"
        plain
        type="primary"
        icon="el-icon-top-left"
      >
        返回
      </el-button>
      <el-table
        class="class_table_data_style"
        :data="question_bank_table"
        border
        stripe
      >
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Name" label="题库"></el-table-column>
        <el-table-column label="操作" min-width="70">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-view"
              size="mini"
              @click="approval(scope.row)"
            >
              查看题库
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="div_type == 'student'">
      <el-button
        @click="return_pag('question_bank')"
        class="question_bank_but"
        size="mini"
        plain
        type="primary"
        icon="el-icon-top-left"
      >
        返回
      </el-button>

      <el-button
        @click="exportExcel"
        class="question_bank_but"
        size="mini"
        type="primary"
        icon="el-icon-download"
      >
        导出表格数据
      </el-button>

      <el-table
        id="out-table"
        class="class_table_data_style"
        :data="student_table"
        border
        stripe
        @expand-change="tab_change"
      >
        <el-table-column type="expand" label="题目" width="80">
          <template slot-scope="props">
            <div v-if="student_table_type">
              <div
                v-for="(item, index) in props.row.data"
                :key="index"
                style="float:left;margin-left: 26px;"
              >
                <p class="que_p_style">
                  第{{ index + 1 }}题:
                  <span
                    v-if="item.Submitted"
                    @click="correction(item)"
                    :style="item.Score == 0 ? 'color:red;' : ''"
                    >{{ item.Score }}</span
                  >
                  <!-- <el-button type="primary" size="mini" v-if="item.Submitted">
                    提交
                  </el-button> -->

                  <el-button type="danger" size="mini" v-if="!item.Submitted"
                    >未做</el-button
                  >
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="学生"></el-table-column>
        <el-table-column prop="totalScore" label="总分"></el-table-column>
      </el-table>
    </div>

    <!-- 做题弹框 -->
    <el-dialog
      title="题目"
      :visible.sync="dialog_add_test_questions"
      :close-on-click-modal="false"
      @close="dialog_close"
      width="80%"
      v-if="form_questions_type"
    >
      <!-- 科目类型 -->
      <div class="questions">
        <p><span>*</span>科目类型</p>
        <div>{{ form_questions.subject }}</div>
      </div>

      <!-- 试题类型 -->
      <div class="questions" v-if="form_questions.subject != 'Scratch'">
        <p><span>*</span>试题类型</p>
        <el-tag>
          {{ form_questions.radio_type }}
        </el-tag>
      </div>

      <div class="questions">
        <p><span>*</span>分数</p>
        <el-input
          disabled
          style="width:300px;"
          placeholder="请输入分数"
          type="number"
          v-model="form_questions.score"
        ></el-input>
      </div>

      <!-- 试题题目 -->
      <div class="questions">
        <p><span>*</span>试题题目</p>
        <p v-html="form_questions.name"></p>
      </div>

      <!-- 试题内容 -->
      <div class="questions">
        <p><span>*</span>试题内容</p>

        <div v-html="form_questions.describe"></div>
      </div>

      <!-- 答案解析 -->
      <div class="questions">
        <p><span>*</span>答案解析</p>
        <div v-html="form_questions.answerAnalysis"></div>
      </div>

      <!-- 试题选项 A -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>A</p>
        <div v-html="form_questions.choices[0]"></div>
      </div>

      <!-- 试题选项 B -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>B</p>
        <div v-html="form_questions.choices[1]"></div>
      </div>

      <!-- 试题选项 C -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>C</p>
        <div v-html="form_questions.choices[2]"></div>
      </div>

      <!-- 试题选项 D -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>D</p>
        <div v-html="form_questions.choices[3]"></div>
      </div>

      <!-- 问答题 -->
      <div
        class="questions"
        v-if="form_questions.radio_type == '问答题' ? true : false"
      >
        <p><span>*</span>问答题</p>
        <quillA v-model="form_questions.blanks"></quillA>

        <p style="margin-top:30px;"><span>*</span>学生提交答案</p>
        <quillA v-model="form_questions.Answer"></quillA>
      </div>

      <div
        class="questions"
        style="margin-top: 30px;"
        v-if="form_questions.radio_type == '问答题' ? false : true"
      >
        <p><span>*</span>试题答案</p>
        <div v-if="form_questions.radio_type == '单选题'">
          <el-radio v-model="form_questions.radio_answer" :label="0">
            A
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="1">
            B
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="2">
            C
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="3">
            D
          </el-radio>
        </div>

        <p
          v-if="form_questions.radio_type == '单选题'"
          style="margin-top: 30px;"
        >
          <span>*</span>学生提交答案
        </p>
        <div v-if="form_questions.radio_type == '单选题'">
          <el-radio v-model="form_questions.Answer" :label="0">
            A
          </el-radio>
          <el-radio v-model="form_questions.Answer" :label="1">
            B
          </el-radio>
          <el-radio v-model="form_questions.Answer" :label="2">
            C
          </el-radio>
          <el-radio v-model="form_questions.Answer" :label="3">
            D
          </el-radio>
        </div>

        <div v-if="form_questions.radio_type == '多选题'">
          <el-checkbox-group v-model="form_questions.checkList">
            <el-checkbox :label="0">A</el-checkbox>
            <el-checkbox :label="1">B</el-checkbox>
            <el-checkbox :label="2">C</el-checkbox>
            <el-checkbox :label="3">D</el-checkbox>
          </el-checkbox-group>
        </div>

        <p
          v-if="form_questions.radio_type == '多选题'"
          style="margin-top: 30px;"
        >
          <span>*</span>学生提交答案
        </p>
        <div v-if="form_questions.radio_type == '多选题'">
          <el-checkbox-group v-model="form_questions.Answer">
            <el-checkbox :label="0">A</el-checkbox>
            <el-checkbox :label="1">B</el-checkbox>
            <el-checkbox :label="2">C</el-checkbox>
            <el-checkbox :label="3">D</el-checkbox>
          </el-checkbox-group>
        </div>

        <div v-if="form_questions.radio_type == '判断题'">
          <el-radio v-model="form_questions.radio_judge" :label="true">
            A. 正确
          </el-radio>
          <el-radio v-model="form_questions.radio_judge" :label="false">
            B. 错误
          </el-radio>
        </div>

        <p
          v-if="form_questions.radio_type == '判断题'"
          style="margin-top: 30px;"
        >
          <span>*</span>学生提交答案
        </p>
        <div v-if="form_questions.radio_type == '判断题'">
          <el-radio v-model="form_questions.Answer" :label="true">
            A. 正确
          </el-radio>
          <el-radio v-model="form_questions.Answer" :label="false">
            B. 错误
          </el-radio>
        </div>

        <div
          class="radio_style"
          v-if="form_questions.radio_type == 'Scratch题'"
        >
          <ul>
            <li>
              <el-button
                @click="to_scratch(true, form_questions.Answer)"
                type="primary"
                size="mini"
              >
                进入Scratch
              </el-button>
              <img src="../assets/stylus/image/default.jpg" />
            </li>
          </ul>
        </div>

        <p
          v-if="form_questions.radio_type == 'Scratch题'"
          style="margin-top: 30px;"
        >
          <span>*</span>学生提交答案
        </p>
        <div
          class="radio_style"
          v-if="form_questions.radio_type == 'Scratch题'"
        >
          <ul>
            <li>
              <el-button
                @click="to_scratch(false, form_questions.Material)"
                type="primary"
                size="mini"
              >
                进入Scratch
              </el-button>
              <img src="../assets/stylus/image/default.jpg" />
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_add_test_questions = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="scoring" size="mini">
          打分
        </el-button>
      </span>
    </el-dialog>

    <!-- 打分弹框 -->
    <el-dialog
      title="打分"
      :visible.sync="dialog_scoring"
      :close-on-click-modal="false"
      width="50%"
    >
      <p style="margin-bottom:12px;color:#999;">
        满分 ({{ form_questions.score }})
      </p>
      <el-input
        type="number"
        clearable
        placeholder="请输入分数"
        v-model="scoring_form.scoring"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_scoring = false" size="mini">
          取消
        </el-button>
        <el-button
          type="success"
          @click="submit_scoring"
          icon="el-icon-check"
          size="mini"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { get_class_api } from "@/api/home.js";
import { get_add_principal } from "@/api/admin.js";
import {
  get_class_sheet_api,
  get_sheet_detail_api,
  get_user_answer_api,
  put_user_answer_api,
  get_score_api,
} from "@/api/question.js";
import quillA from "./components/quill_editor_A.vue";
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    quillA,
    loading,
  },
  data() {
    return {
      dialog_question_management: false,
      dialog_add_test_questions: false,
      form_questions_type: false,
      div_type: "class",
      class_table_data: [], //班级表格数据
      question_bank_table: [], //题库表格数据
      question_tableData_ls: [],
      student_table: [], //学生表格数据
      student_table_type: false,
      question_tableData: [],
      form_questions: {
        score: "",
        name: "", //试题题目
        describe: "", //试题内容
        answerAnalysis: "", //答案解析
        blanks: "", //简答题
        choices: [],
        radio_type: "单选题", //题目类型
        radio_answer: "",
        radio_judge: true,
        checkList: [],
        subject: "",
      },
      question_id: "",
      dialog_scoring: false,
      scoring_form: { id: "", scoring: "" },
      xls_title: "",
      loading_ok: "",
    };
  },

  created() {
    // 获取班级
    get_class_api(this.current).then((res) => {
      this.class_table_data = res.data;
      this.loading_ok = false;
    });
  },

  methods: {
    //进入试卷
    to_testPaper(item) {
      let data = {
        domain: {
          group: "CLASS",
          name: item.Slug,
        },
        subject: {
          group: "ROLE",
          name: "STUDENT",
        },
      };
      // 获取班级下面的学生
      get_add_principal(data).then((res) => {
        this.student_table = res.data;
      });

      // 获取班级下面的题库
      get_class_sheet_api(item.Id).then((res) => {
        if (res.data.length) {
          this.question_bank_table = res.data;
          this.div_type = "question_bank";
        }
      });
    },

    //返回
    return_pag(type) {
      this.div_type = type;
    },

    //查看题库
    approval(item) {
      this.xls_title = item.Name + ".xlsx";
      this.student_table.forEach((r, i) => {
        get_score_api(r.Name, item.Id).then((res) => {
          r.totalScore = res.data.Score;
          if (this.student_table.length == i + 1) {
            this.div_type = "student";
          }
        });
      });

      get_sheet_detail_api(item.Id).then((res) => {
        this.question_tableData = res.data.Questions;
        this.question_id = res.data.Questions[0].Id;
      });
    },

    //做题按钮
    edit_form_question(item) {
      this.dialog_add_test_questions = true;
      this.form_questions_type = true;
      this.form_questions.name = "";
      this.form_questions.id = item.Id;
      this.form_questions.score = item.Score;
      this.form_questions.answerAnalysis = item.AnswerAnalysis;
      if (item.Type == "SingleChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.subject = item.Subject;
        this.form_questions.radio_type = "单选题";
        this.form_questions.choices = item.ExtraField.SingleChoiceField.Choices;
        this.form_questions.radio_answer =
          item.ExtraField.SingleChoiceField.Answer;
        this.form_questions.Answer = item.Answer.SingleChoice;
      } else if (item.Type == "MultiChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "多选题";
        this.form_questions.subject = item.Subject;
        this.form_questions.choices = item.ExtraField.MultiChoiceField.Choices;
        this.form_questions.checkList = item.ExtraField.MultiChoiceField.Answer;
        this.form_questions.Answer = item.Answer.MultiChoice;
      } else if (item.Type == "TrueFalseQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "判断题";
        this.form_questions.subject = item.Subject;
        this.form_questions.radio_judge = item.ExtraField.TrueFalseField.Answer;
        this.form_questions.Answer = item.Answer.TrueFalse;
      } else if (item.Type == "AnswerQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "问答题";
        this.form_questions.subject = item.Subject;
        this.form_questions.blanks = item.ExtraField.AnswerField.Answer;
        this.form_questions.Answer = item.Answer.Answer;
      } else if (item.Type == "ScratchQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "Scratch题";
        this.form_questions.subject = item.Subject;
        this.form_questions.Material = item.Answer.Scratch;
        this.form_questions.Answer = item.ExtraField.ScratchField.Answer;
      }
    },

    //批改
    correction(item) {
      this.scoring_form.id = item.Id;
      if (!item.Submitted) {
        this.$message.error("该学生未提交此题！");
        return false;
      }
      this.question_tableData.forEach((v) => {
        if (item.QuestionId == v.Id) {
          v.Answer = item.Answer;
          this.question_tableData_ls.push(v);
        }
      });
      this.edit_form_question(this.question_tableData_ls[0]);
    },

    //提交
    submit_test_paper() {
      this.dialog_question_management = false;
      //   put_submission_api(this.question_id).then(() => {
      //      this.$message.success("提交成功！");
      //      this.dialog_question_management = false;
      //   })
    },

    //打分
    scoring() {
      this.dialog_scoring = true;
    },

    //打分弹框确定按钮
    submit_scoring() {
      if (!this.scoring_form.scoring) {
        this.$message.error("分数不能为空！");
        return false;
      }

      if (this.scoring_form.scoring <= this.form_questions.score) {
        put_user_answer_api(
          this.scoring_form.id,
          this.scoring_form.scoring
        ).then(() => {
          this.$message.success("批改成功！");
          this.dialog_scoring = false;
        });
      } else {
        this.$message.error(
          "批改分数不能大于" + " " + this.form_questions.score + "!"
        );
      }
    },

    //监听添加试题弹框关闭事件
    dialog_close() {
      this.form_questions_type = false;
      this.question_tableData_ls = [];
    },

    //监听表格打开关闭
    tab_change(item, type) {
      if (type.length) {
        let arr = [];
        this.question_tableData.forEach((v) => {
          get_user_answer_api(v.Id, item.Name).then((res) => {
            console.log(res.data);
            arr.push(res.data);
            this.student_table.forEach((t) => {
              if (t.Name == item.Name) {
                t.data = arr;
                this.student_table_type = false;
                this.student_table_type = true;
              }
            });
          });
        });
      }
    },

    //进入sc编辑器
    to_scratch(type, id) {
      if (type) {
        var url = "/scratch/?answer=" + id + "&teacherMaterial=" + id;
        window.open(url);
      } else {
        var url = "/scratch/?id=" + id + "&teacherMaterial=" + id;
        window.open(url);
      }
      console.log(id);
    },

    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          this.xls_title
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }

    .class_table_data_style {
      margin-top: 20px;
    }

    .question_bank_but {
       margin-top:30px;
    }

    .questions {
    background:#f8f8f8;
    border:1px solid #f3f3f3;
    padding:16px;
    border-radius:6px;
    margin-bottom:30px;
    p {
      margin-bottom:14px;
      span {
        color:#F56C6C;
        margin-right:4px;
      }
    }
  }
}

>>>.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

>>>.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

>>>.el-date-editor.el-input {
  width: auto;
}

>>>.el-dialog__footer {
  margin-top:0px;
}

>>>.el-radio__label {
  padding-left: 0;
}

.vhtml_img >>> img {
   width: 100px;
}

.que_p_style {
  padding:8px 0px 12px 0px;
  span {
     color:#409EFF;
     margin-left:6px;
     cursor: pointer;
  }

  .el-button {
    padding:2px 6px;
  }
}

.radio_style {
    ul {
      width:100%;
      display:flex;
      li {
        width:14%;
        height:200px;
        background:#ccc;
        margin-right:20px;
        overflow:hidden;
        position:relative
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
        .el-button {
          position:absolute;
          bottom:8%;
          left:50%;
          transform:translateX(-50%);
        }
        img {
          height:100%;
        }
      }
    }
  }
</style>
